module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-menu-ba4586a95a5d0c5903b876f1336d7b9d.svg";